import { FMSRStore } from 'app/store/store';
import { AxiosRequestConfig } from 'axios';

export const tenantIdInterceptor =
  (store: FMSRStore) =>
  async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
    const { tenantId } = store.getState().workstation;
    // @ts-ignore
    // eslint-disable-next-line no-param-reassign
    config.headers['Tenant-Id'] = tenantId;
    return config;
  };
